export default __webpack_public_path__ + "static/media/Landing_Logo_Amcham.9796cd18.png";